"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbToRgba = void 0;
var tslib_1 = require("tslib");
var rgbToRgba = function (_a, a) {
    var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
    if (a === void 0) { a = 1; }
    return [r, g, b, a];
};
exports.rgbToRgba = rgbToRgba;
